import { createStyles } from "@material-ui/core";

const customerStyle = createStyles(() => ({
  divider: {
    margin: "15px 0 15px 0",
  },
}));

export default customerStyle;
